import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { PaginasWebTable } from "./paginas-web-table";
import { PaginaWebForm } from "./pagina-web-form";
import { PaginasWebProvider } from "./paginas-web-context";

export function PaginasWebRoutes() {
  return (
    <RoleGuard roles={["empresa:paginas-web"]}>
      <PaginasWebProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<PaginasWebTable />} />

            <Route path="add" element={<PaginaWebForm />} />

            <Route path=":pagina_web_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<PaginaWebForm />} />
            </Route>

            <Route path="*" element="PaginasWeb: Page Not Found" />
          </Route>
        </Routes>
      </PaginasWebProvider>
    </RoleGuard>
  );
}
